"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Number_1 = require("./Number");
Object.defineProperty(exports, "Number", { enumerable: true, get: function () { return Number_1.Number; } });
//# sourceMappingURL=index.js.map